import { useEffect, useState } from "react"
import { MdErrorOutline, MdOutlineEventAvailable } from "react-icons/md"
import { useNavigate, useParams } from "react-router-dom"
import Spinner from "../../Components/Spinner"
import { createNewUser } from "../../Requests/firebaseAuth"
import { createGroupDoc, createUserDoc, getExhibitorsDocWhereEmail, getInviteDoc, updateExhibitor, updateInviteStatus } from "../../Requests/firebaseFirestore"
import { setExhibitorContact } from "../../Requests/sendMail"

export default function NewExhibitorPage(){
  const {inviteId} = useParams()
  const navigate = useNavigate()
  const [invite, setInvite] = useState({})
  const [loading, setLoading] = useState(true)
  const [sending, setSending] = useState(false)
  const [newUser, setNewUser] = useState({})
  const [error, setError] = useState(false)
  const [exhibitor, setExhibitor] = useState({})
  const [disabled, setDisabled] = useState(false)
  const [authError, setAuthError] = useState('')
  const handleInputChange = (e) => {
    setAuthError("")
    const {name, value} = e.target
    setNewUser({...newUser,[name]: value})
  }

  useEffect(()=>{
    const getInvite = async () => {
      const res = await getInviteDoc(inviteId)
      if(res){
        const exh = await getExhibitorsDocWhereEmail(res.email)
        if(exh.length===0){
          setNewUser({
            fullName:'',
            email:res.email,
            password:'',
            company:res.company
          })
        }else{
          setNewUser('user-exists')
          setExhibitor(exh[0])
          let check = true
          exh[0].events.forEach((event)=>{
            if(event.id===res.event.id){
              check = false
            }
          })
          if(!check){
            setDisabled(true)
          }
        }
        setInvite(res)
      }else{
        setError(true)
      }
      setLoading(false)
    }

    getInvite()
  },[inviteId])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSending(true)
    if(newUser.password === newUser.repeatPassword){
      const res = await createNewUser(newUser.email, newUser.password)
      if(res.status ==='success'){
        await createUserDoc({
          uid:res.user.uid,
          fullName:newUser.fullName,
          company:newUser.company,
          email:newUser.email,
          type:'user',
          role:'exhibitor',
          brands:[{id:invite.event.id, brands: []}],
          events:[{...invite.event}],
          position:newUser.position,
          phone:newUser.phone
        })
        await createGroupDoc({name:`Solicitudes de reunión ${invite.event.name}`, event:invite.event, exhibitor:{fullName:newUser.fullName, id:res.user.uid}, type:'meetings', guests:[]})
        await updateInviteStatus(inviteId)
        await setExhibitorContact(invite.event.id, newUser.email) 
        setNewUser('user-exists')
        setDisabled(true)
      }else{
        switch (res.error.code) {
          case 'auth/weak-password':
            setAuthError('La contraseña debe tener más de 6 caracteres')
            break;
          case 'auth/email-already-in-use':
            setAuthError('Ya existe una cuenta asignada al email ingresado')
            break;
          default:
            setAuthError('Ha ocurrido un error desconocido, por favor intente más tarde')
            break;
        }
      }
    }else{
      setAuthError('Las contraseñas ingresadas son diferentes.')
    }

    setSending(false)
  }

  const handleOldUser = async () => {
    let check = true
    exhibitor.events.forEach((event)=>{
      if(event.id===invite.event.id){
        check = false
      }
    })
    if(check){
      console.log(invite.event.id, exhibitor.email)
      await setExhibitorContact(invite.event.id, exhibitor.email)
      await updateExhibitor(exhibitor.id, {events:[...exhibitor.events, {...invite.event}], brands:[...exhibitor.brands, {id:invite.event.id, brands:[]}]})
      await createGroupDoc({name:`Solicitudes de reunión ${invite.event.name}`, event:invite.event, exhibitor:{fullName:exhibitor.fullName, id:exhibitor.id}, type:'meetings', guests:[]})
      await updateInviteStatus(inviteId)
      setDisabled(true)
    }

  }

  return(<>
  {loading?<>
  <div className="text-white">
    <Spinner/>
  </div>
  </>:<>
  {error?
      <div className="bg-white rounded-[10px] py-4 px-3 w-1/2 max-w-[500px] mx-auto flex flex-col justify-center items-center">
        <span className="text-[#F03623]"><MdErrorOutline size={150}/></span>
        <span>La invitación ya no es válida</span>
      </div>
      :

    <div className="bg-white rounded-[10px] py-4 px-3 w-1/2 max-w-[500px] min-w-[350px] mx-auto flex flex-col justify-start items-center gap-4">
      {newUser==='user-exists'?
      <>
        <span className="text-[#F03623]"><MdOutlineEventAvailable size={150}/></span>
        <h1 className="text-center">Invitación para {invite.event.name}</h1>
        {disabled?
        <>
        <span className="font-semibold text-[#392C75]">Ya estas participando</span>
        <button className="send-btn" onClick={()=>{navigate('/exhibitor/groups')}}>Ir a la consola</button></>
        :<>
          <button className="send-btn" onClick={handleOldUser} disabled={sending}>{sending?'Cargando...':'Participar'}</button>
        </>}
      </>
    :
    <>
      <h1 className="text-2xl text-[#392C75] font-semibold text-center">Invitación para {invite.event.name}</h1>
      {authError!==''?
      <div className="w-[75%] py-2 px-3 border rounded-[10px] border-[#EE2325] text-[#EE2325] text-center">
        <span>{authError}</span>
      </div>:<></>}
      <form className="flex flex-col gap-4 w-[75%]" onSubmit={handleSubmit} id='user-form'>
        <div className="input-holder w-full">
          <input type="text" name="fullName" id="new-user-fullName" value={newUser.fullName || ''} onChange={handleInputChange} required/>
          <label htmlFor="new-user-fullName">Nombre completo</label>
        </div>
        <div className="input-holder w-full">
          <input type="email" name="email" id="new-user-email" value={invite.email} required readOnly/>
          <label htmlFor="new-user-email">Email</label>
        </div>
        <div className="input-holder w-full">
          <input type="password" name="password" id="new-user-password" value={newUser.password || ''} onChange={handleInputChange} required/>
          <label htmlFor="new-user-password">Contraseña</label>
        </div>
        <div className="input-holder w-full">
          <input type="password" name="repeatPassword" id="new-user-repeat-password" value={newUser.repeatPassword || ''} onChange={handleInputChange} required/>
          <label htmlFor="new-user-repeat-password">Repetir contraseña</label>
        </div>
        <div className="input-holder w-full">
          <input type="text" name="company" id="new-user-company" value={invite.company} required readOnly/>
          <label htmlFor="new-user-company">Empresa</label>
        </div>
        <div className="input-holder w-full">
          <input type="text" name="position" id="new-user-position" value={newUser.position || ''} onChange={handleInputChange} required/>
          <label htmlFor="new-user-position">Cargo</label>
        </div>
        <div className="input-holder w-full">
          <input type="text" name="phone" id="new-user-phone" value={newUser.phone || ''} onChange={handleInputChange} required/>
          <label htmlFor="new-user-phone">Número de teléfono</label>
        </div>
      </form>
        <button className=" send-btn" form="user-form" disabled={sending}>{sending?'Cargando...':'Crear cuenta'}</button>
      </>
      }
    </div>
    }
  </>}
  </>)
}